import {useMutation} from 'react-query';
import {postLoanRequestFile} from './postLoanRequestFile';

const usePostLoanRequestFile = () => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IPostLoanRequestFilePayload) =>
      postLoanRequestFile(payload),
  });

  return {mutateFile: mutate, isLoadingFile: isLoading};
};

export default usePostLoanRequestFile;
